module.exports = __webpack_public_path__ + "static/media/nc.cf0be09f.svg";